import React from "react";
import {
  fetchBreederDeliveryRecords
} from "./../../../actions/medicalRecords";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import moment from "moment";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import "react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css";
import filterFactory, {} from "react-bootstrap-table2-filter";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import { BreadCrumb } from "../../../components/breadcrumb";

const $ = window.$;
const { SearchBar } = Search;

var toaOptions = {};
var rtOptions = {};
var tableHeaderColumnData = [];

class CenteredTabs extends React.Component {
  constructor(props) {
    super(props);
  }
  state = {
    openNew: false,
    confirmDelete: false,
    dataBreederDelivery: [],
    dataBreederSendData: '',
    loadingDelete: false,
    deleteMRId: null
  };

  tableHeaderColumnData = [
    {
      dataField: "actions",
      text: "Actions",
      formatter: this.buttonFormatter.bind(this),
      style: { "overflowX": "visible" }
    },

    {
      dataField: "id",
      text: "Id",
      sort: true,
      formatter: (cell, row) => {
        return (
        <span className="m-badge m-badge--info mx-auto my-0 px-2">
            <strong>{cell}</strong>
        </span>
          
        );
      }
    },
    {
      dataField: "PetShopId",
      text: "Pet ShopId",
      sort: true
    },
    {
      dataField: "breeder",
      text: "Breeder",
      sort: true,
      formatter: cell => cell
    },
    {
      dataField: "createdAt",
      text: "Created Date",
      formatter: cell => moment(cell).format("MM-DD-YYYY"),
      sort: true
    },
    {
      dataField: "usda_no",
      text: "USDA",
      sort: true
    }
  ];

  buttonFormatter(cell, row) {
    return (
      <div>
        <button
          onClick={(e) => this.openDeliveryModal(e,row)}
          className="m-portlet__nav-link btn m-btn m-btn--hover-brand m-btn--icon m-btn--icon-only m-btn--pill"
          title="View"
        >
          <i className="far fa-eye"></i>
        </button>
      </div>
    );
  }

  openDeliveryModal(e, data) {
    e.preventDefault();
    this.setState({ dataBreederSendData: data });
    $("#delivery_modal").modal("show");
  }

  componentDidMount() {
    this.props.fetchBreederDeliveryRecords();
  }

  componentWillReceiveProps = nextProps => {

    if (this.props.toa !== nextProps.toa) {
      let i = 0;
      for (let t of nextProps.toa) {
        toaOptions[i] = t.type;
        i++;
      }
    }
    if (this.props.reg_types !== nextProps.reg_types) {
      let i = 0;
      for (let t of nextProps.reg_types) {
        rtOptions[i] = t.type;
        i++;
      }
    }
  
    if (
        nextProps.data.medicalRecordsReducer.breedersDeliveryRecords !==
        this.props.data.medicalRecordsReducer.breedersDeliveryRecords
    ) {
        let BreederDeliveryrecords = nextProps.data.medicalRecordsReducer.breedersDeliveryRecords;
        
        this.setState({
          dataBreederDelivery: BreederDeliveryrecords
        });
    }

    // if (
    //   nextProps.data.medicalRecordsReducer.breedersDeliveryRecords !==
    //   this.props.data.medicalRecordsReducer.breedersDeliveryRecords
    // ) {
    //   this.props.fetchBreederDeliveryRecords();
    // }
  };

  items = [{ title: "Breeders Delivery Records", to: "/breeders/deliveryList" }];

  render() {
    const { dataBreederDelivery } = this.state;

    let breedersListData

    if(this.state.dataBreederSendData){
        breedersListData = this.state.dataBreederSendData
    }

    return (
      <div className="m-grid m-grid--hor m-grid--root m-page">
        <div className="m-grid__item m-grid__item--fluid m-grid m-grid--hor-desktop m-grid--desktop m-body body-background">
          <BreadCrumb items={this.items} />
          <div className="m-grid__item m-grid__item--fluid  m-grid m-grid--ver	m-container m-container--responsive m-container--xxl m-page__container">
            <div className="m-grid__item m-grid__item--fluid m-wrapper">
              <div className="m-portlet m-portlet--mobile">
                <div className="m-portlet__head">
                  <div className="m-portlet__head-caption">
                    <div className="m-portlet__head-title">
                      <h3 className="m-portlet__head-text">
                        Breeders Delivery Records
                        <small>List of all the delivery records</small>
                      </h3>
                    </div>
                  </div>
                </div>
                <div className="m-portlet__body">
                  <div className="tab-content">
                    <ToolkitProvider
                      keyField="id"
                      data={dataBreederDelivery}
                      columns={this.tableHeaderColumnData}
                      search                      
                      hover={true}
                      filter={filterFactory()}
                    >
                      {props => (
                        <div>
                          <div className="px-0 mb-4 search-bar">
                            <div className="col-lg-3 px-0 inner-addon right-addon">
                              <i className="fas fa-search"></i>
                              <SearchBar {...props.searchProps} />
                            </div>
                          </div>
                          <div className="mb-2">
                            <small className="small-text">
                              *If you experience any difficulty in viewing the
                              medical record, please make sure your cache is
                              cleared and completed a hard refresh. IOS users
                              might have to use a private window.
                            </small>
                          </div>
                         
                          <BootstrapTable 
                            classes="petTable"
                            {...props.baseProps}
                            pagination={paginationFactory()}
                          />
                         
                        </div>
                      )}
                    </ToolkitProvider>
                  </div>
                </div>
              </div>
              <div
                className="modal fade"
                id="delivery_modal"
                tabIndex="-1"
                role="dialog"
                aria-labelledby="ConfirmationModalLabel"
                aria-hidden="true"
              >
                <div className="modal-dialog" role="document">
                  <div className="modal-content">
                    <div className="modal-header">
                      <h5 className="modal-title" id="exampleModalLabel">
                        View Delivery List
                      </h5>
                      <button
                        type="button"
                        className="close"
                        data-dismiss="modal"
                        aria-label="Close"
                      >
                        <span aria-hidden="true">&times;</span>
                      </button>
                    </div>
                    <div className="modal-body">
                      <div>
                          <div>
                            {this.state.dataBreederSendData ?
                              <div>
                                <div>Pick up {breedersListData.MedicalRecords.length} Puppies From:</div>
                                <br/>
                                <div>{breedersListData.breeder}</div>
                                <div>{breedersListData.phone}</div>
                                <div>{breedersListData.addressLine1}</div>
                                <div>{breedersListData.addressLine2},{breedersListData.addressCity},{breedersListData.addressState},{breedersListData.addressPostalCode}</div>
                                <br/>
                                <div>Drop off:</div>
                                <br/>

                                {breedersListData.MedicalRecords.map((b, id) => {
                                  return (
                                    <div key={id}>
                                      { b.Contract != null ?
                                      
                                        <div>
                                          <div>{b.Contract.Customer.firstname} {b.Contract.Customer.lastname}</div>
                                          <div>{b.Contract.Customer.address},{b.Contract.Customer.city}</div>
                                          <div>{b.Contract.Customer.state} {b.Contract.Customer.zip_code}</div>
                                          <div>{b.Contract.Customer.phone_primary} {b.Contract.Customer.phone_secondary ? " or "+b.Contract.Customer.phone_secondary : "null"}</div>
                                        </div>

                                      : 
                                      <div>
                                        <div>{b.PetShop.title}</div>
                                        <div>{b.PetShop.address},{b.PetShop.country}</div>
                                        <div>{b.PetShop.phone_number}</div>
                                      </div>  
                                      }

                                      <div>{b.Breed.breed_type} , {b.sex} , {b.pet_id}</div>
                                      <br/>
                                    </div>
                                  )
                                })}
                              </div>
                            : null }
                          </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>                
    );
  }
}

const mapStateToProps = state => ({
  data: state
});

const mapDispatchToProps = dispatch => ({
  fetchBreederDeliveryRecords: () => {
    dispatch(fetchBreederDeliveryRecords());
  }
});

CenteredTabs = connect(mapStateToProps, mapDispatchToProps)(CenteredTabs);

export default withRouter(CenteredTabs);
